// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./brand-tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared base for both apps (Ask Pastor Rob and the team portal).
 * Values come from brand-tokens.css (a copy of campaign/brand/tokens.css);
 * the rules are BRAND_SPEC.md's. Night is the default; Light reading (Day,
 * cream) is data-theme="day" on <html> and only the public app offers it.
 *
 * Nothing here colours a <p>, paints an input white or styles a scrollbar
 * light: those were the old light-theme leaks (BRAND_SPEC §11.1).
 */

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

html {
  -webkit-text-size-adjust: 100%;
  overflow-x: hidden;
  background: var(--brand-bg);
}

body {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  background: var(--brand-bg);
  color: var(--brand-fg);
  font-family: var(--font-sans);
  font-size: 1rem;
  line-height: 1.5;
  font-feature-settings: "kern" 1, "liga" 1, "calt" 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Every control inherits the brand face (they used to fall back to Arial).
   Zero specificity, so the input sizes below and every component win. */
:where(button, input, select, textarea) {
  font: inherit;
  color: inherit;
  letter-spacing: inherit;
}

:where(button) {
  background: none;
  border: 0;
  cursor: pointer;
}

button:disabled {
  cursor: default;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-sans);
  font-weight: 600;
  line-height: 1.25;
  color: var(--brand-fg);
}

img,
svg,
video {
  max-width: 100%;
}

a {
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

a:hover {
  text-decoration-thickness: 2px;
}

::selection {
  background: var(--brand-fg);
  color: var(--brand-bg);
}

/* Focus: a 2 px ring with a 2 px offset ring, on every control (§11.0). */
:focus-visible {
  outline: 2px solid var(--brand-focus);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--brand-focus-offset);
}

:focus:not(:focus-visible) {
  outline: none;
}

/* Inputs (§11.0): the raised surface, a control edge, 17 px text (16 px or
   more stops iOS zooming). Zero specificity, so components refine them. */
:where(input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]), textarea) {
  width: 100%;
  min-height: 52px;
  padding: 12px 14px;
  font-size: 1.0625rem;
  font-weight: 400;
  line-height: 1.4;
  color: var(--brand-fg);
  background: var(--brand-surface);
  border: 1px solid var(--brand-line-control);
  border-radius: var(--radius-md);
  caret-color: var(--brand-caret);
  -webkit-appearance: none;
  appearance: none;
}

:where(select) {
  min-height: 48px;
  padding: 10px 12px;
  font-size: 1rem;
  color: var(--brand-fg);
  background-color: var(--brand-surface);
  border: 1px solid var(--brand-line-control);
  border-radius: var(--radius-md);
}

:where(input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]), textarea, select):focus {
  outline: none;
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
}

::placeholder {
  color: var(--brand-subtle);
  opacity: 1;
}

:where(input[type="checkbox"], input[type="radio"]) {
  accent-color: var(--brand-fg);
  width: 20px;
  height: 20px;
}

/* Scrollbars stay in the dark (they were near-white). */
* {
  scrollbar-color: var(--brand-line-control) transparent;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--brand-line);
  border: 2px solid var(--brand-bg);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--brand-line-control);
}

/* ---------------------------------------------------------------- utilities */

.apr-sr-only {
  position: absolute !important;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.apr-icon {
  flex: none;
  display: block;
}

/* Labels: sentence case, 13 px, never tracked or upper-cased (§6.5). */
.apr-label {
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-muted);
  letter-spacing: 0;
  text-transform: none;
}

/* Buttons (§11.0). Guest surfaces: the line button is the primary and
   nothing routine is filled. Team surfaces (the portal) may use --fill,
   once per card. */
.apr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 18px;
  border-radius: var(--radius-md);
  border: 2px solid var(--brand-fg);
  background: transparent;
  color: var(--brand-fg);
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);
}

.apr-btn:hover {
  text-decoration: none;
  background: var(--brand-surface);
}

.apr-btn:active {
  background: var(--brand-surface-2);
}

.apr-btn--lg {
  min-height: 56px;
  font-size: 1.0625rem;
}

.apr-btn--quiet {
  border-width: 1px;
  border-color: var(--brand-line-control);
}

.apr-btn--text {
  min-height: 44px;
  padding: 0 4px;
  border-color: transparent;
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
}

.apr-btn--text:hover {
  background: none;
  text-decoration-thickness: 2px;
}

.apr-btn--fill {
  background: var(--brand-accent);
  border-color: var(--brand-accent);
  color: var(--brand-accent-ink);
}

.apr-btn--fill:hover {
  background: var(--brand-accent);
  color: var(--brand-accent-ink);
}

.apr-btn--fill:active {
  background: var(--brand-muted);
  border-color: var(--brand-muted);
}

.apr-btn--block {
  width: 100%;
}

.apr-btn:disabled,
.apr-btn[aria-disabled="true"] {
  border-color: var(--brand-line-control);
  color: var(--brand-line-control);
  background: transparent;
  cursor: default;
}

.apr-btn--fill:disabled {
  background: transparent;
}

/* Round icon buttons: 44 px, quiet (1 px) unless they are the live action. */
.apr-icon-btn {
  flex: none;
  display: inline-grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-fg);
  cursor: pointer;
}

.apr-icon-btn:hover {
  background: var(--brand-surface-2);
}

.apr-icon-btn--bare {
  border-color: transparent;
}

.apr-icon-btn--line {
  border: 2px solid var(--brand-fg);
}

.apr-icon-btn:disabled {
  color: var(--brand-line-control);
  border-color: var(--brand-line-control);
  background: transparent;
}

/* Errors are words with an icon, never colour alone (§11.0). */
.apr-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--brand-danger);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.45;
}

.apr-error .apr-icon {
  margin-top: 1px;
}

/* Notices that confirm something happened: plain, with a check. */
.apr-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--brand-fg-read);
  font-size: 0.9375rem;
  line-height: 1.45;
}

/* ------------------------------------------------- dialogs and sheets (§11.0)
   A scrim, then the one raised surface. On phones a dialog is a sheet that
   rises from the bottom (top radius 16, a grabber, a control-edge top line);
   on wider screens it sits centred. Every one also closes with a button and
   with Escape: nothing is swipe-only. */

.apr-overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: var(--brand-scrim);
  overflow-y: auto;
  animation: aprScrimIn var(--dur-fast) var(--ease-out);
}

.apr-dialog {
  position: relative;
  width: 100%;
  max-width: 440px;
  margin: auto;
  padding: 24px 24px 20px;
  background: var(--brand-surface);
  color: var(--brand-fg);
  border: 1px solid var(--brand-line-control);
  border-radius: var(--radius-lg);
  animation: aprSheetIn var(--dur-base) var(--ease-out);
}

.apr-dialog-grabber {
  display: none;
}

.apr-dialog-title {
  margin: 0 0 8px;
  font-size: 1.25rem;
  line-height: 1.3;
  font-weight: 600;
  color: var(--brand-fg);
}

.apr-dialog-body {
  margin: 0 0 12px;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--brand-fg-read);
}

.apr-dialog-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.apr-dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
}

@keyframes aprScrimIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes aprSheetIn {
  from { transform: translateY(16px); }
  to { transform: none; }
}

@media (max-width: 600px) {
  .apr-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .apr-dialog {
    max-width: none;
    margin: auto 0 0;
    padding: 12px 20px calc(20px + env(safe-area-inset-bottom, 0px));
    border: 0;
    border-top: 1px solid var(--brand-line-control);
    border-radius: 16px 16px 0 0;
  }

  .apr-dialog-grabber {
    display: block;
    width: 36px;
    height: 4px;
    margin: 0 auto 16px;
    border-radius: 2px;
    background: var(--brand-line-control);
  }

  .apr-dialog-actions {
    flex-direction: column;
  }

  .apr-dialog-actions .apr-btn {
    width: 100%;
  }

  @keyframes aprSheetIn {
    from { transform: translateY(100%); }
    to { transform: none; }
  }
}

/* Switches (Light reading, AI Rob's voice): words plus a track and a knob;
   "on" is a filled knob at the far end and aria-checked, never colour alone. */
.apr-switch-track {
  flex: none;
  position: relative;
  width: 40px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid var(--brand-line-control);
  background: transparent;
}

.apr-switch-track::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--brand-muted);
  background: transparent;
  transition: transform var(--dur-fast) var(--ease-out);
}

[aria-checked="true"] > .apr-switch-track,
[aria-pressed="true"] > .apr-switch-track {
  border: 2px solid var(--brand-fg);
}

[aria-checked="true"] > .apr-switch-track::after,
[aria-pressed="true"] > .apr-switch-track::after {
  top: 2px;
  left: 2px;
  border-color: var(--brand-fg);
  background: var(--brand-fg);
  transform: translateX(16px);
}

/* First paint while auth settles (also inlined in index.html). */
.loading-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--brand-bg);
  color: var(--brand-fg);
}

.loading-container .apr-mark {
  display: block;
}

.loading-text {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--brand-muted);
}

/* Reduced motion: final states only. No typing, blinking, moving or fading
   anywhere (BRAND_SPEC §9.5, WCAG 2.2 SC 2.3.3). Transitions are switched
   off outright, not shortened: a 0.01 ms transition still defers every
   style change by a frame (the default transition-property is "all"), and
   the conversation measures its own layout synchronously. */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    animation-delay: 0ms !important;
    transition-duration: 0s !important;
    transition-delay: 0s !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAGF;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mDAAmD;EACnD,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;wEACwE;AACxE;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,qCAAqC;EACrC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;0EAC0E;AAC1E;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;EACtC,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+EAA+E;;AAE/E;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;mBAEmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,uCAAuC;EACvC,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;;wCAIwC;;AAExC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,2CAA2C;EAC3C,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,eAAe,EAAE;AACxB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gEAAgE;IAChE,SAAS;IACT,+CAA+C;IAC/C,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,KAAK,eAAe,EAAE;EACxB;AACF;;AAEA;+EAC+E;AAC/E;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;4DAI4D;AAC5D;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,+BAA+B;IAC/B,kCAAkC;IAClC,+BAA+B;IAC/B,gCAAgC;EAClC;AACF","sourcesContent":["/*\n * Shared base for both apps (Ask Pastor Rob and the team portal).\n * Values come from brand-tokens.css (a copy of campaign/brand/tokens.css);\n * the rules are BRAND_SPEC.md's. Night is the default; Light reading (Day,\n * cream) is data-theme=\"day\" on <html> and only the public app offers it.\n *\n * Nothing here colours a <p>, paints an input white or styles a scrollbar\n * light: those were the old light-theme leaks (BRAND_SPEC §11.1).\n */\n@import './brand-tokens.css';\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  overflow-x: hidden;\n  background: var(--brand-bg);\n}\n\nbody {\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  background: var(--brand-bg);\n  color: var(--brand-fg);\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  line-height: 1.5;\n  font-feature-settings: \"kern\" 1, \"liga\" 1, \"calt\" 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n/* Every control inherits the brand face (they used to fall back to Arial).\n   Zero specificity, so the input sizes below and every component win. */\n:where(button, input, select, textarea) {\n  font: inherit;\n  color: inherit;\n  letter-spacing: inherit;\n}\n\n:where(button) {\n  background: none;\n  border: 0;\n  cursor: pointer;\n}\n\nbutton:disabled {\n  cursor: default;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-sans);\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--brand-fg);\n}\n\nimg,\nsvg,\nvideo {\n  max-width: 100%;\n}\n\na {\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\na:hover {\n  text-decoration-thickness: 2px;\n}\n\n::selection {\n  background: var(--brand-fg);\n  color: var(--brand-bg);\n}\n\n/* Focus: a 2 px ring with a 2 px offset ring, on every control (§11.0). */\n:focus-visible {\n  outline: 2px solid var(--brand-focus);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 2px var(--brand-focus-offset);\n}\n\n:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Inputs (§11.0): the raised surface, a control edge, 17 px text (16 px or\n   more stops iOS zooming). Zero specificity, so components refine them. */\n:where(input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"file\"]), textarea) {\n  width: 100%;\n  min-height: 52px;\n  padding: 12px 14px;\n  font-size: 1.0625rem;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--brand-fg);\n  background: var(--brand-surface);\n  border: 1px solid var(--brand-line-control);\n  border-radius: var(--radius-md);\n  caret-color: var(--brand-caret);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n:where(select) {\n  min-height: 48px;\n  padding: 10px 12px;\n  font-size: 1rem;\n  color: var(--brand-fg);\n  background-color: var(--brand-surface);\n  border: 1px solid var(--brand-line-control);\n  border-radius: var(--radius-md);\n}\n\n:where(input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"file\"]), textarea, select):focus {\n  outline: none;\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n}\n\n::placeholder {\n  color: var(--brand-subtle);\n  opacity: 1;\n}\n\n:where(input[type=\"checkbox\"], input[type=\"radio\"]) {\n  accent-color: var(--brand-fg);\n  width: 20px;\n  height: 20px;\n}\n\n/* Scrollbars stay in the dark (they were near-white). */\n* {\n  scrollbar-color: var(--brand-line-control) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--brand-line);\n  border: 2px solid var(--brand-bg);\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-line-control);\n}\n\n/* ---------------------------------------------------------------- utilities */\n\n.apr-sr-only {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\n.apr-icon {\n  flex: none;\n  display: block;\n}\n\n/* Labels: sentence case, 13 px, never tracked or upper-cased (§6.5). */\n.apr-label {\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-muted);\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n/* Buttons (§11.0). Guest surfaces: the line button is the primary and\n   nothing routine is filled. Team surfaces (the portal) may use --fill,\n   once per card. */\n.apr-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 0 18px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--brand-fg);\n  background: transparent;\n  color: var(--brand-fg);\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);\n}\n\n.apr-btn:hover {\n  text-decoration: none;\n  background: var(--brand-surface);\n}\n\n.apr-btn:active {\n  background: var(--brand-surface-2);\n}\n\n.apr-btn--lg {\n  min-height: 56px;\n  font-size: 1.0625rem;\n}\n\n.apr-btn--quiet {\n  border-width: 1px;\n  border-color: var(--brand-line-control);\n}\n\n.apr-btn--text {\n  min-height: 44px;\n  padding: 0 4px;\n  border-color: transparent;\n  text-decoration-line: underline;\n  text-underline-offset: 0.2em;\n}\n\n.apr-btn--text:hover {\n  background: none;\n  text-decoration-thickness: 2px;\n}\n\n.apr-btn--fill {\n  background: var(--brand-accent);\n  border-color: var(--brand-accent);\n  color: var(--brand-accent-ink);\n}\n\n.apr-btn--fill:hover {\n  background: var(--brand-accent);\n  color: var(--brand-accent-ink);\n}\n\n.apr-btn--fill:active {\n  background: var(--brand-muted);\n  border-color: var(--brand-muted);\n}\n\n.apr-btn--block {\n  width: 100%;\n}\n\n.apr-btn:disabled,\n.apr-btn[aria-disabled=\"true\"] {\n  border-color: var(--brand-line-control);\n  color: var(--brand-line-control);\n  background: transparent;\n  cursor: default;\n}\n\n.apr-btn--fill:disabled {\n  background: transparent;\n}\n\n/* Round icon buttons: 44 px, quiet (1 px) unless they are the live action. */\n.apr-icon-btn {\n  flex: none;\n  display: inline-grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-fg);\n  cursor: pointer;\n}\n\n.apr-icon-btn:hover {\n  background: var(--brand-surface-2);\n}\n\n.apr-icon-btn--bare {\n  border-color: transparent;\n}\n\n.apr-icon-btn--line {\n  border: 2px solid var(--brand-fg);\n}\n\n.apr-icon-btn:disabled {\n  color: var(--brand-line-control);\n  border-color: var(--brand-line-control);\n  background: transparent;\n}\n\n/* Errors are words with an icon, never colour alone (§11.0). */\n.apr-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  color: var(--brand-danger);\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.apr-error .apr-icon {\n  margin-top: 1px;\n}\n\n/* Notices that confirm something happened: plain, with a check. */\n.apr-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  color: var(--brand-fg-read);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n}\n\n/* ------------------------------------------------- dialogs and sheets (§11.0)\n   A scrim, then the one raised surface. On phones a dialog is a sheet that\n   rises from the bottom (top radius 16, a grabber, a control-edge top line);\n   on wider screens it sits centred. Every one also closes with a button and\n   with Escape: nothing is swipe-only. */\n\n.apr-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 120;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: var(--brand-scrim);\n  overflow-y: auto;\n  animation: aprScrimIn var(--dur-fast) var(--ease-out);\n}\n\n.apr-dialog {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  margin: auto;\n  padding: 24px 24px 20px;\n  background: var(--brand-surface);\n  color: var(--brand-fg);\n  border: 1px solid var(--brand-line-control);\n  border-radius: var(--radius-lg);\n  animation: aprSheetIn var(--dur-base) var(--ease-out);\n}\n\n.apr-dialog-grabber {\n  display: none;\n}\n\n.apr-dialog-title {\n  margin: 0 0 8px;\n  font-size: 1.25rem;\n  line-height: 1.3;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.apr-dialog-body {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  line-height: 1.55;\n  color: var(--brand-fg-read);\n}\n\n.apr-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.apr-dialog-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n@keyframes aprScrimIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes aprSheetIn {\n  from { transform: translateY(16px); }\n  to { transform: none; }\n}\n\n@media (max-width: 600px) {\n  .apr-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .apr-dialog {\n    max-width: none;\n    margin: auto 0 0;\n    padding: 12px 20px calc(20px + env(safe-area-inset-bottom, 0px));\n    border: 0;\n    border-top: 1px solid var(--brand-line-control);\n    border-radius: 16px 16px 0 0;\n  }\n\n  .apr-dialog-grabber {\n    display: block;\n    width: 36px;\n    height: 4px;\n    margin: 0 auto 16px;\n    border-radius: 2px;\n    background: var(--brand-line-control);\n  }\n\n  .apr-dialog-actions {\n    flex-direction: column;\n  }\n\n  .apr-dialog-actions .apr-btn {\n    width: 100%;\n  }\n\n  @keyframes aprSheetIn {\n    from { transform: translateY(100%); }\n    to { transform: none; }\n  }\n}\n\n/* Switches (Light reading, AI Rob's voice): words plus a track and a knob;\n   \"on\" is a filled knob at the far end and aria-checked, never colour alone. */\n.apr-switch-track {\n  flex: none;\n  position: relative;\n  width: 40px;\n  height: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n}\n\n.apr-switch-track::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--brand-muted);\n  background: transparent;\n  transition: transform var(--dur-fast) var(--ease-out);\n}\n\n[aria-checked=\"true\"] > .apr-switch-track,\n[aria-pressed=\"true\"] > .apr-switch-track {\n  border: 2px solid var(--brand-fg);\n}\n\n[aria-checked=\"true\"] > .apr-switch-track::after,\n[aria-pressed=\"true\"] > .apr-switch-track::after {\n  top: 2px;\n  left: 2px;\n  border-color: var(--brand-fg);\n  background: var(--brand-fg);\n  transform: translateX(16px);\n}\n\n/* First paint while auth settles (also inlined in index.html). */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--brand-bg);\n  color: var(--brand-fg);\n}\n\n.loading-container .apr-mark {\n  display: block;\n}\n\n.loading-text {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--brand-muted);\n}\n\n/* Reduced motion: final states only. No typing, blinking, moving or fading\n   anywhere (BRAND_SPEC §9.5, WCAG 2.2 SC 2.3.3). Transitions are switched\n   off outright, not shortened: a 0.01 ms transition still defers every\n   style change by a frame (the default transition-property is \"all\"), and\n   the conversation measures its own layout synchronously. */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    animation-delay: 0ms !important;\n    transition-duration: 0s !important;\n    transition-delay: 0s !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
